import FullWidthLayout from "@/layouts/FullWidthLayout";
import OutboundFreightReport from "kinnect-front/Warehouse/Reports/OutboundFreightReport";
import Pageable from "@/mixins/pageable";

export default {
	name: "WarehouseOutboundFreightReportPage",

	metaInfo: { title: "Warehouse - Outbound Freight Report" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<OutboundFreightReport></OutboundFreightReport>
		</FullWidthLayout>;
	}
};
